module.exports = __webpack_public_path__ + "static/alarm.05e6bd35.svg";